import { render } from "./adminlistsub.vue?vue&type=template&id=d18c01b6&scoped=true&ts=true"
import script from "./adminlistsub.vue?vue&type=script&lang=ts"
export * from "./adminlistsub.vue?vue&type=script&lang=ts"

import "./adminlistsub.vue?vue&type=style&index=0&id=d18c01b6&lang=scss&scoped=true"
import "./adminlistsub.vue?vue&type=style&index=1&id=d18c01b6&lang=scss"

import exportComponent from "D:\\code\\GWSD\\ttnewadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18c01b6"]])

export default __exports__